import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AccessibilityTabContent, AccessibilityTabs, AccessibilityBypassBlock, AccessibilityHiddenImg } from '@skillz/accessibility';
import { removeSlashes } from "../../../utils/utils";
import MenuMobile from "./menuMobile/MenuMobile";
import pathRouts from "../../../enums/pathRoute";
import HeaderMobile from "./headerMobile/HeaderMobile";
import ScrollLTR from "../../ui/scrollLTR/ScrollLTR";
import notMobileAccess from '../../../assests/notMobileAccess.png'
import LandscapeMessage from "./landscapeMessage/LandscapeMessage";
import classes from './LayoutMobile.module.css';

const LayoutMobile = () => {

    const { pathname } = useLocation();
    const { texts, lang } = useSelector(state => state.translate);
    const isHome = removeSlashes(pathname) === pathRouts.HOME.route;

    const mainMenuTabsId = "main-menu-tabs";

    return (
        <AccessibilityTabs id={mainMenuTabsId} >
            <AccessibilityTabContent
                hidden={false}
                id={`${mainMenuTabsId}-${pathname}`}>
                <div className={`${classes.Layout} ${classes[`MyLang_${lang}`]} ${isHome ? classes.IsHomePage : ''}`}>
                    <AccessibilityBypassBlock id="main" text={texts.skipToMainContent} />

                    {window.config.hiddenMobile ?
                        <AccessibilityHiddenImg className={classes.NotMobileAccess} src={notMobileAccess} />
                        :
                        <>
                            <HeaderMobile />
                            <ScrollLTR dropClass={classes.LayoutContent}>
                                <div id="main" className={classes.MainWrapper}>
                                    <Outlet></Outlet>
                                </div>
                            </ScrollLTR>
                            <MenuMobile id={mainMenuTabsId} />
                        </>
                    }
                    <LandscapeMessage />
                </div>
            </AccessibilityTabContent>
        </AccessibilityTabs>
    )
}
export default LayoutMobile;